export const API_ROUTES = {
  TIPS: {
    STATS: '/tips/stats',
    LIST: '/tips',
    BY_ID: (id: string) => `/tips/${id}`,
  },
  CONNECT: {
    BALANCE: '/connect/balance',
    INSTANT_PAYOUTS: '/connect/instant-payouts',
  },
  USERS: {
    ME: '/users/me',
  },
} as const;
